// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"5c66b8a5","114":"17349c7b","821":"aa75eedb","878":"c0156a6b","943":"097ae016"}[chunkId] + ".chunk.css";
};